import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--tabs"
export default class extends Controller {
  static targets = ["tab", "panel", "select"]
  static values = { active: String }

  connect() {
    // Set initial active tab
    if (this.activeValue) {
      this.showTab(this.activeValue)
    } else if (this.tabTargets.length > 0) {
      const firstTab = this.tabTargets[0].dataset.tabName
      this.showTab(firstTab)
    }
  }

  select(event) {
    const tabName = event.currentTarget.dataset.tabName
    this.showTab(tabName)
  }

  selectFromDropdown(event) {
    this.showTab(event.target.value)
  }

  showTab(name) {
    this.activeValue = name

    // Update tabs
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tabName === name
      tab.classList.toggle("border-primary-500", isActive)
      tab.classList.toggle("text-primary-600", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-gray-500", !isActive)
      tab.classList.toggle("hover:border-gray-200", !isActive)
      tab.classList.toggle("hover:text-gray-700", !isActive)
      tab.setAttribute("aria-selected", isActive)

      // Update badge styling
      const badge = tab.querySelector("[data-tab-badge]")
      if (badge) {
        badge.classList.toggle("bg-primary-100", isActive)
        badge.classList.toggle("text-primary-600", isActive)
        badge.classList.toggle("bg-gray-100", !isActive)
        badge.classList.toggle("text-gray-900", !isActive)
      }
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.tabName === name
      panel.classList.toggle("hidden", !isActive)
    })

    // Update mobile select
    if (this.hasSelectTarget) {
      this.selectTarget.value = name
    }
  }
}
